import { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      {icon && (
        <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-500" aria-hidden="true">
          {icon}
        </div>
      )}
      <h3 className="text-lg font-medium text-slate-800 dark:text-slate-300">{title}</h3>
      {description && (
        <p className="mt-1 max-w-sm text-sm text-slate-600 dark:text-slate-500">{description}</p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}